import { Content } from "@/ui/Content";
import * as additionalComponents from "@/components/IR35Page";
import { router } from "@/router";
import { stripTags } from "@/functions/stripTags";
import { getGlobal } from "@/functions/getGlobal";
import { insights_helper } from "@/helpers/insights_helper";
import sourceflowEnums from "@/sourceflow.enums";

export default function Page({ content }) {
  return (
    <>
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps({}) {
  const global = getGlobal();
  const insights = insights_helper.fetch({ limit: 3, filter: (i) => i?.tags?.includes("IR35") });

  const routerProp = router["ir35"];
  const titleKey = "page.ir35.banner.title";

  return {
    props: {
      meta: {
        en: {
          title: stripTags(global[`${titleKey}.en`]),
          canonical: `${sourceflowEnums.config.baseUrl}${routerProp["en"]}`,
        },
      },
      router: routerProp,
      content: [
        { component: "IR35PageBannerSection", props: { className: "" } },
        { component: "IR35PageContentSection", props: { className: "py-4 py-md-5" } },
        {
          component: "InsightsSection",
          props: { className: "py-4 py-md-5", title: { path: "page.ir35.insights.title" }, items: insights },
        },
        { component: "IR35PageAssessmentToolSection" },
        { component: "IR35PageLinksSection" },
      ],
    },
  };
}
